import { TextVariant } from "@gx/dls/text/Text";

import { WikipediaPageEstimateSeverity } from "@/pages/sources/components/create/sources/wikipedia/types";

export const SOURCE_WIKIPEDIA_DEFAULT_LINKS_PER_PAGE = 1;
export const SOURCE_WIKIPEDIA_DEFAULT_CRAWL_DEPTH = 0;
export const SOURCE_WIKIPEDIA_DEFAULT_MAX_PAGES = 100;

export const SOURCE_WIKIPEDIA_MIN_LINKS_PER_PAGE = 1;
export const SOURCE_WIKIPEDIA_MAX_LINKS_PER_PAGE = 20;

export const SOURCE_WIKIPEDIA_MIN_CRAWL_DEPTH = 0;
export const SOURCE_WIKIPEDIA_MAX_CRAWL_DEPTH = 4;

export const SOURCE_WIKIPEDIA_MIN_MAX_PAGES = 1;
export const SOURCE_WIKIPEDIA_MAX_MAX_PAGES = 100;

export const SOURCE_WIKIPEDIA_CONFIGURATION_CASE = "sourceWikipedia";

export const CREATE_SOURCE_WIKIPEDIA_SEED_URL_REQUIRED_ERROR = "Wikipedia URL is required";
export const CREATE_SOURCE_WIKIPEDIA_INVALID_URL_ERROR = "Please enter a valid Wikipedia URL";
export const CREATE_SOURCE_WIKIPEDIA_MAX_PAGES_RANGE_ERROR =
  "Page limit must be between 1 and 1000";

export const SOURCE_WIKIPEDIA_PAGE_ESTIMATE_SEVERITY_TO_TEXT_VARIANT_MAP: Record<
  WikipediaPageEstimateSeverity,
  TextVariant
> = {
  [WikipediaPageEstimateSeverity.SUCCESS]: TextVariant.SUCCESS,
  [WikipediaPageEstimateSeverity.CAUTION]: TextVariant.YELLOW,
  [WikipediaPageEstimateSeverity.WARNING]: TextVariant.ORANGE,
  [WikipediaPageEstimateSeverity.ERROR]: TextVariant.ERROR,
};
